import React from 'react';
import ReactDOM from 'react-dom/client';
// Import API config early to set axios defaults globally
import './config/api';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

